/**
 * Cloud Attack Path Queries
 *
 * Pre-built queries for cloud infrastructure privilege escalation paths.
 * Currently focuses on AWS IAM attack primitives.
 *
 * To add new cloud query: Add query object to CLOUD_ATTACK_PATH_QUERIES array.
 * Query will automatically appear in defaultQueries.ts export.
 */

import type { SavedQuery } from '@/sections/insights/queryBuilder/types/SavedQuery';

import { QueryFolders } from './folders';

export const CLOUD_ATTACK_PATH_QUERIES: SavedQuery[] = [
  {
    id: 'aws-iam-createpolicyversion-paths',
    name: 'AWS IAM PutRolePolicy Privilege Escalation Paths',
    type: 'graph',
    description:
      'Identify AWS resources that have PutRolePolicy over another role. This technique allows attackers to modify existing IAM policy versions to grant themselves additional permissions.',
    folderId: QueryFolders.CLOUD_ATTACK_PATHS,
    query: {
      node: {
        labels: ['AWSResource'],
        filters: [],
        relationships: [
          {
            label: 'IAM_PUTROLEPOLICY',
            optional: false,
            target: {
              labels: ['AWSResource'],
              filters: [],
              relationships: [],
            },
          },
        ],
      },
      limit: 200,
      shortest: 1,
    },
  },
];
